var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWandStars24DpE3E3E3Fill0Wght400Grad0Opsz24 = function SvgWandStars24DpE3E3E3Fill0Wght400Grad0Opsz24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "#e3e3e3",
    viewBox: "0 -960 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m176-120-56-56 301-302-181-45 198-123-17-234 179 151 216-88-87 217 151 178-234-16-124 198-45-181zm24-520-80-80 80-80 80 80zm355 197 48-79 93 7-60-71 35-86-86 35-71-59 7 92-79 49 90 22zm165 323-80-80 80-80 80 80zM569-570"
  })));
};
export default SvgWandStars24DpE3E3E3Fill0Wght400Grad0Opsz24;